import OverlayModal from "../model/OverlayModalProductsTags"

const ProductTagsTableRow = ({row, actionComponent, checkBoxComponent}: any) => {
  return (
    <tr>
      {checkBoxComponent && <td>{checkBoxComponent(row)}</td>}
      <td>
        <div className='d-flex align-items-center py-2'>
          <div className='symbol symbol-40px me-3 border'>
            <img src={row.thumbnail_url} alt='productimage' />
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-semibold'>{row['product_name']}</div>
            <div>
              <strong> {row['variant_options']}</strong>
            </div>
          </div>
        </div>
      </td>
      <td>
        <div className='fw-semibold'>{row['tableSku']}</div>
      </td>
      <td>
        <div>
          {row['tags'].length &&
            row['tags'] &&
            row['tags'].map((i: any) => (
              <span className='text-uppercase badge badge-light m-1 p-3 text-gray-800'>{i}</span>
            ))}
        </div>
      </td>
      {actionComponent && (
        <td className='text-start'>
          <div className=''>
            <OverlayModal row={row} />
          </div>
        </td>
      )}
    </tr>
  )
}

export default ProductTagsTableRow
